import { render } from "./ContactTagCard.vue?vue&type=template&id=3e858922"
import script from "./ContactTagCard.vue?vue&type=script&lang=js"
export * from "./ContactTagCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__